var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownload2Icon = function SvgDownload2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.852 15.492a.19.19 0 0 0 .23.053.2.2 0 0 0 .066-.053l2.625-3.32a.187.187 0 0 0-.148-.303h-1.737V3.938a.19.19 0 0 0-.187-.188h-1.407a.19.19 0 0 0-.187.188v7.928H9.375a.187.187 0 0 0-.148.303zm8.726-.82h-1.406a.19.19 0 0 0-.188.187v3.61H5.016v-3.61a.19.19 0 0 0-.188-.187H3.422a.19.19 0 0 0-.188.187V19.5c0 .415.336.75.75.75h16.032a.75.75 0 0 0 .75-.75v-4.64a.19.19 0 0 0-.188-.188"
  })));
};
export default SvgDownload2Icon;